// src/pages/CheatSheet.js
import React, { useEffect, useState } from "react";
import { fetchFormulas } from "../api";

export default function CheatSheet() {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    fetchFormulas()
      .then(d => { setCategories(d); setLoading(false); })
      .catch(e => { setError(e.message); setLoading(false); });
  }, []);

  const downloadTopic = (cat) => {
    const content = `${cat.topic} (${cat.subject}) Formulas\n` +
      "=".repeat(30) + "\n\n" +
      cat.formulas.map(f => `${f.name}:\n   ${f.rule}`).join("\n\n") +
      "\n\nGenerated by PrepAct";
    
    const blob = new Blob([content], { type: "text/plain" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `${cat.topic}_Formulas.txt`;
    a.click();
    URL.revokeObjectURL(url);
  };

  const subjectIcons = {
    Quant: "📐",
    Reasoning: "🧩",
    English: "📖",
    "GA & Banking": "🏦"
  };

  if (loading) return <div className="loading"><div className="spinner" /><span>Loading formulas…</span></div>;

  return (
    <div className="fade-in">
      <h1 className="page-title">Cheat Sheets</h1>
      <p className="page-sub">Quick reference formulas and rules for all exam topics</p>

      {error && <div className="error-box" style={{ marginTop: 16 }}>{error}</div>}

      <div style={{ 
        display: "grid", 
        gridTemplateColumns: "repeat(auto-fill, minmax(340px, 1fr))", 
        gap: 20, 
        marginTop: 24 
      }}>
        {categories.map(cat => (
          <div key={cat.id} className="card" style={{ 
            display: "flex", 
            flexDirection: "column",
            position: "relative",
            overflow: "hidden",
            border: "1px solid var(--border)",
            padding: 0
          }}>
            {/* Header */}
            <div style={{ 
              padding: "16px 20px", 
              borderBottom: "1px solid var(--border)",
              background: "var(--bg)",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center"
            }}>
              <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                <span style={{ fontSize: 20 }}>{subjectIcons[cat.subject] || "📝"}</span>
                <div>
                  <div style={{ fontSize: 14, fontWeight: 700 }}>{cat.topic}</div>
                  <div style={{ fontSize: 11, color: "var(--text-muted)", textTransform: "uppercase", letterSpacing: 0.5 }}>{cat.subject}</div>
                </div>
              </div>
              <button 
                className="btn btn-sm btn-blue" 
                onClick={() => downloadTopic(cat)}
                style={{ height: 32, borderRadius: 8, padding: "0 12px" }}
              >
                📥 Download
              </button>
            </div>

            {/* List */}
            <div style={{ padding: "16px 20px", flex: 1 }}>
              {cat.formulas.map((f, i) => (
                <div key={i} style={{ 
                  marginBottom: i === cat.formulas.length - 1 ? 0 : 14,
                  padding: "10px 12px",
                  background: "var(--surface)",
                  borderRadius: 10,
                  border: "1px solid var(--border)"
                }}>
                  <div style={{ fontSize: 12, fontWeight: 600, color: "var(--blue)", marginBottom: 4 }}>{f.name}</div>
                  <div style={{ 
                    fontSize: 13, 
                    fontFamily: "var(--font-mono)", 
                    color: "var(--text-primary)", 
                    lineHeight: 1.5,
                    wordBreak: "break-word"
                  }}>
                    {f.rule}
                  </div>
                </div>
              ))}
            </div>

            {/* Subtle background decoration */}
            <div style={{ 
              position: "absolute", 
              right: -20, 
              bottom: -20, 
              fontSize: 100, 
              opacity: 0.03, 
              pointerEvents: "none",
              userSelect: "none"
            }}>
              {subjectIcons[cat.subject] || "📝"}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
